import styled, { keyframes, css } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const StyledNavContainer = styled.div`
  width: 100%;
  position relative;
  background-color: ${props => props.background};
  box-shadow: none;
  font-family: mm-main, arial, sans-serif;
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fonts.defaultSize};
  z-index: 11;
  animation: ${props =>
    props.isSticky
      ? css`
          ${fadeIn}
        `
      : 'none'} 0.25s ease-in-out;

  @media (min-width: ${props => props.theme.screen.md}) {
    border-bottom: 3px solid;
    border-color: ${props => props.theme.colors.primary};
  }
`;

export const StyledNav = styled.nav`
  @media (min-width: ${props => props.theme.screen.xl}) {
    margin: auto;
  }
  max-width: ${props => props.theme.sizes.maxWidth};
  position: relative;
  box-sizing: border-box;
`;

export const StyledAssurance = styled.div`
  display: flex;
`;
